import React, { useEffect, useState } from 'react';
import { FaPlus, FaEdit, FaTrash, FaSave, FaTimes } from 'react-icons/fa';
import { ReactComponent as ArrowDownIcon } from "../assets/arrow-down.svg";
import { ReactComponent as ArrowIcon } from "../assets/arrow.svg";
import { ReactComponent as Close } from '../assets/closeBtn.svg';
import { useSelector } from 'react-redux';
import axios from 'axios';
import config from '../config';

const VictoryDetail = ({ title, setSelected }) => {
    const [victoryData, setVictoryData] = useState(null);
    const [openItems, setOpenItems] = useState({});
    const [isEditing, setIsEditing] = useState(false);
    const [editingData, setEditingData] = useState(null);
    const adminMode = useSelector((state) => state.adminMode.adminMode);
    const initData = window.Telegram.WebApp.initData;
    const [allData, setAllData] = useState([]);
    const [newSection, setNewSection] = useState({
        subtitle: '',
        text: '',
        items: []
    });

    useEffect(() => {
        axios.get(`${config.API_BASE_URL}/victories`)
            .then(({ data }) => {
                if (data.success) {
                    setAllData(data.data);
                    const foundData = data.data.find(item => item.title === title);
                    setVictoryData(foundData);
                    setEditingData(foundData);
                }
            })
            .catch(error => {
                console.error('Ошибка при загрузке данных:', error);
            });
    }, [title]);

    const handleSave = async () => {
        try {
            const updatedData = allData.map(item =>
                item.title === title ? editingData : item
            );

            await axios.post(`${config.API_BASE_URL}/victories/save`, {
                initData,
                data: updatedData
            });

            setVictoryData(editingData);
            setAllData(updatedData);
            setIsEditing(false);
        } catch (error) {
            console.error('Ошибка при сохранении:', error);
        }
    };

    const toggleItem = (index) => {
        setOpenItems(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };
    const handleClose = () => {
        setSelected(null)
    };

    const handleAddSection = () => {
        setEditingData(prev => ({
            ...prev,
            details: [...(prev.details || []), newSection]
        }));
        setNewSection({ subtitle: '', text: '', items: [] });
    };

    const handleDeleteSection = (index) => {
        setEditingData(prev => ({
            ...prev,
            details: prev.details.filter((_, i) => i !== index)
        }));
    };

    const handleEditSection = (index, field, value) => {
        setEditingData(prev => ({
            ...prev,
            details: prev.details.map((detail, i) =>
                i === index ? { ...detail, [field]: value } : detail
            )
        }));
    };

    const handleAddItem = (sectionIndex) => {
        setEditingData(prev => ({
            ...prev,
            details: prev.details.map((detail, i) =>
                i === sectionIndex ? {
                    ...detail,
                    items: [...(detail.items || []), { title: '', description: '' }]
                } : detail
            )
        }));
    };

    const handleEditItem = (sectionIndex, itemIndex, field, value) => {
        setEditingData(prev => ({
            ...prev,
            details: prev.details.map((detail, i) =>
                i === sectionIndex ? {
                    ...detail,
                    items: detail.items.map((item, j) =>
                        j === itemIndex ? { ...item, [field]: value } : item
                    )
                } : detail
            )
        }));
    };

    const handleDeleteItem = (sectionIndex, itemIndex) => {
        setEditingData(prev => ({
            ...prev,
            details: prev.details.map((detail, i) =>
                i === sectionIndex ? {
                    ...detail,
                    items: detail.items.filter((_, j) => j !== itemIndex)
                } : detail
            )
        }));
    };

    const renderResource = () => {
        if (!victoryData.resource) return null;

        const isVideo = /\.(mp4|webm)$/i.test(victoryData.resource);
        const isAudio = /\.(mp3|wav|ogg)$/i.test(victoryData.resource);
        const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(victoryData.resource);

        if (isVideo) {
            return (
                <div className="resource-container">
                    <h3 className="resource-title">{victoryData.title?.toUpperCase()}</h3>
                    <div className="video-wrapper">
                        <video width="100%" controls>
                            <source src={victoryData.resource} type="video/mp4" />
                        </video>
                        <span className="play-hint">Для просмотра видео нажмите на кнопку PLAY</span>
                        <div className="scroll-hint">
                            <ArrowIcon />
                        </div>
                    </div>
                </div>
            );
        }

        if (isAudio) {
            return (
                <div className="resource-container">
                    <audio controls>
                        <source src={victoryData.resource} />
                    </audio>
                </div>
            );
        }

        if (isImage) {
            return (
                <div className="resource-container">
                    <img src={victoryData.resource} alt="Изображение" />
                </div>
            );
        }

        return null;
    };

    const handleEditResource = (value) => {
        setEditingData(prev => ({
            ...prev,
            resource: value
        }));
    };

    if (!victoryData) {
        return <div>Загрузка...</div>;
    }

    return (
        <div className="victory-detail">
            <div className='victory-head'>
                <div className="close-btn" onClick={handleClose}>
                    <Close />
                </div>
                <h2>
                    {victoryData.desk}
                </h2>
            </div>

            {adminMode && (
                <div className="edit-mode-toggle">
                    <button
                        className={`edit-button ${isEditing ? 'active' : ''}`}
                        onClick={() => setIsEditing(!isEditing)}
                    >
                        <FaEdit />
                        {isEditing ? 'Режим просмотра' : 'Режим редактирования'}
                    </button>
                </div>
            )}

            {isEditing ? (
                <div className="edit-form">
                    <div className="resource-edit">
                        <input
                            type="text"
                            value={editingData?.resource || ''}
                            onChange={(e) => handleEditResource(e.target.value)}
                            placeholder="Ссылка на видео/аудио/изображение"
                        />
                    </div>
                    {editingData?.details?.map((detail, index) => (
                        <div key={index} className="section-edit">
                            <div className="section-header">
                                <input
                                    value={detail.subtitle || ''}
                                    onChange={(e) => handleEditSection(index, 'subtitle', e.target.value)}
                                    placeholder="Подзаголовок"
                                />
                                <button onClick={() => handleDeleteSection(index)}>
                                    <FaTrash />
                                </button>
                            </div>

                            <textarea
                                value={detail.text || ''}
                                onChange={(e) => handleEditSection(index, 'text', e.target.value)}
                                placeholder="Текст раздела"
                            />

                            <div className="items-edit">
                                {detail.items?.map((item, itemIndex) => (
                                    <div key={itemIndex} className="item-edit">
                                        <input
                                            value={item.title}
                                            onChange={(e) => handleEditItem(index, itemIndex, 'title', e.target.value)}
                                            placeholder="Название пункта"
                                        />
                                        <textarea
                                            value={item.description}
                                            onChange={(e) => handleEditItem(index, itemIndex, 'description', e.target.value)}
                                            placeholder="Описание пункта"
                                        />
                                        <button onClick={() => handleDeleteItem(index, itemIndex)}>
                                            <FaTrash />
                                        </button>
                                    </div>
                                ))}
                                <button onClick={() => handleAddItem(index)}>
                                    <FaPlus /> Добавить пункт
                                </button>
                            </div>
                        </div>
                    ))}

                    <div className="new-section">
                        <input
                            value={newSection.subtitle}
                            onChange={(e) => setNewSection(prev => ({ ...prev, subtitle: e.target.value }))}
                            placeholder="Новый подзаголовок"
                        />
                        <textarea
                            value={newSection.text}
                            onChange={(e) => setNewSection(prev => ({ ...prev, text: e.target.value }))}
                            placeholder="Новый текст"
                        />
                        <button onClick={handleAddSection}>
                            <FaPlus /> Добавить раздел
                        </button>
                    </div>

                    <div className="edit-controls">
                        <button onClick={handleSave}>
                            <FaSave /> Сохранить
                        </button>
                        <button onClick={() => setIsEditing(false)}>
                            <FaTimes /> Отмена
                        </button>
                    </div>
                </div>
            ) : (
                <>
                    {renderResource()}
                    {victoryData.details?.map((detail, index) => (
                        <div key={index} className="victory-section">
                            {detail.subtitle && (
                                <div className="victory-subtitle">{detail.subtitle}</div>
                            )}
                            {detail.text && <p className="victory-text">{detail.text}</p>}
                            {detail.items && detail.items.length > 0 && (
                                <ul className="victory-list">
                                    {detail.items.map((item, i) => (
                                        <React.Fragment key={i}>
                                            <li
                                                className={`victory-item ${openItems[`${index}-${i}`] ? 'open' : ''}`}
                                                onClick={() => toggleItem(`${index}-${i}`)}
                                            >
                                                <span className="item-text">{item.title}</span>
                                                <button className="toggle-btn">
                                                    <ArrowDownIcon />
                                                </button>
                                            </li>
                                            {openItems[`${index}-${i}`] && (
                                                <div className="victory-details">
                                                    {item.description || 'Описание отсутствует'}
                                                </div>
                                            )}
                                        </React.Fragment>
                                    ))}
                                </ul>
                            )}
                        </div>
                    ))}
                </>
            )}
        </div>
    );
};

export default VictoryDetail;
